import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-[#1a3a52] text-[#f5f1e8]/60 py-8 border-t border-[#d4af37]/20" data-id="element-47">
        <div className="max-w-7xl mx-auto px-4" data-id="element-48">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-49">
            <p className="text-sm" data-id="element-50">
              &copy; {new Date().getFullYear()} Desbloquea Tu Potencial. Todos
              los derechos reservados.
            </p>

            <div className="flex items-center gap-6" data-id="element-51">
              <button onClick={() => setPrivacyOpen(true)} className="text-sm hover:text-[#d4af37] transition-colors" data-id="element-52">
                Política de Privacidad
              </button>
              <span className="text-[#d4af37]/30" data-id="element-53">|</span>
              <button onClick={() => setTermsOpen(true)} className="text-sm hover:text-[#d4af37] transition-colors" data-id="element-54">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-55">
        <div className="space-y-6 text-sm leading-relaxed" data-id="element-56">
          <p className="text-base font-medium text-[#1a3a52]" data-id="element-57">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section className="space-y-3" data-id="element-58">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-59">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-60">
              Recopilamos información que nos proporcionas directamente, como tu
              nombre y dirección de correo electrónico cuando realizas una
              compra o te suscribes a nuestra lista de correo.
            </p>
          </section>

          <section className="space-y-3" data-id="element-61">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-62">
              2. Uso de la Información
            </h3>
            <p data-id="element-63">Utilizamos la información recopilada para:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-64">
              <li data-id="element-65">Procesar y entregar tu compra</li>
              <li data-id="element-66">Enviarte actualizaciones sobre tu pedido</li>
              <li data-id="element-67">Responder a tus consultas y solicitudes</li>
              <li data-id="element-68">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section className="space-y-3" data-id="element-69">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-70">
              3. Protección de Datos
            </h3>
            <p data-id="element-71">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción.
            </p>
          </section>

          <section className="space-y-3" data-id="element-72">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-73">
              4. Tus Derechos
            </h3>
            <p data-id="element-74">
              Tienes derecho a acceder, rectificar o eliminar tu información
              personal. También puedes oponerte al procesamiento de tus datos o
              solicitar la portabilidad de los mismos.
            </p>
          </section>

          <section className="space-y-3" data-id="element-75">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-76">
              5. Cookies
            </h3>
            <p data-id="element-77">
              Utilizamos cookies para mejorar tu experiencia en nuestro sitio
              web. Puedes configurar tu navegador para rechazar cookies, aunque
              esto puede afectar algunas funcionalidades.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-78">
        <div className="space-y-6 text-sm leading-relaxed" data-id="element-79">
          <p className="text-base font-medium text-[#1a3a52]" data-id="element-80">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section className="space-y-3" data-id="element-81">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-82">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-83">
              Al acceder y utilizar este sitio web y adquirir nuestros productos
              digitales, aceptas estar sujeto a estos términos y condiciones de
              uso.
            </p>
          </section>

          <section className="space-y-3" data-id="element-84">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-85">
              2. Productos Digitales
            </h3>
            <p data-id="element-86">
              Los productos ofrecidos son guías digitales en formato PDF. Una
              vez realizada la compra, recibirás acceso inmediato al material a
              través del correo electrónico proporcionado.
            </p>
          </section>

          <section className="space-y-3" data-id="element-87">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-88">
              3. Política de Reembolso
            </h3>
            <p data-id="element-89">
              Debido a la naturaleza digital de nuestros productos, no ofrecemos
              reembolsos una vez que el producto ha sido entregado. Te
              recomendamos revisar toda la información disponible antes de
              realizar tu compra.
            </p>
          </section>

          <section className="space-y-3" data-id="element-90">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-91">
              4. Propiedad Intelectual
            </h3>
            <p data-id="element-92">
              Todo el contenido de este sitio web y los productos digitales,
              incluyendo textos, gráficos y diseños, están protegidos por
              derechos de autor. No está permitida la reproducción o
              distribución sin autorización.
            </p>
          </section>

          <section className="space-y-3" data-id="element-93">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-94">
              5. Uso Personal
            </h3>
            <p data-id="element-95">
              Los productos adquiridos son para uso personal únicamente. No está
              permitido compartir, revender o distribuir el contenido a
              terceros.
            </p>
          </section>

          <section className="space-y-3" data-id="element-96">
            <h3 className="font-serif font-bold text-lg text-[#1a3a52]" data-id="element-97">
              6. Limitación de Responsabilidad
            </h3>
            <p data-id="element-98">
              El contenido de nuestras guías es de carácter informativo y no
              sustituye el consejo profesional médico o psicológico. No nos
              hacemos responsables por los resultados individuales obtenidos.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}